var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"absolute inset-0 bg-gray-500 bg-opacity-75 z-50 flex items-center justify-center p-4"},[_c('div',{staticClass:"p-4 rounded bg-gray-50 shadow-lg"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }